export default __webpack_public_path__ + "static/noissuetv-7694ef12194a5d142365fdf8e8482671.svg";